<script>
import { UnsignedByteType } from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { mapState, mapActions } from 'vuex';
export default {
    props: ['sky'],
    data() {
        return {};
    },
    computed: {
        ...mapState('spinner', [
            'scene',
            'backgroundScene',
            'envMap',
            'loadingManager',
            'pmremGenerator'
        ])
    },
    mounted: function() {
        this.$nextTick(function() {
            new RGBELoader()
                .setDataType(UnsignedByteType)
                .load('images/textures/cube/autoshop_01_1k.hdr', texture => {
                    const envMap = this.pmremGenerator.fromEquirectangular(
                        texture
                    ).texture;
                    this.pmremGenerator.dispose();
                    this.setEnvMap(envMap);
                });
            // let urls = [
            //     'cubemap_left.jpg',
            //     'cubemap_right.jpg',
            //     'cubemap_top.jpg',
            //     'cubemap_bottom.jpg',
            //     'cubemap_front.jpg',
            //     'cubemap_back.jpg'
            // ];
            // let textureCube = new CubeTextureLoader(this.loadingManager)
            //     .setPath('images/textures/cube/Esplanade/')
            //     .load(
            //         urls,
            //         // eslint-disable-next-line no-unused-vars
            //         texture => {
            //             //console.log('loaded');
            //         },
            //         // eslint-disable-next-line no-unused-vars
            //         xhr => {
            //             //console.log('progress...');
            //         },
            //         // eslint-disable-next-line no-unused-vars
            //         error => {
            //             //console.log('error!', error);
            //         }
            //     );
            // textureCube.format = RGBFormat;
            // this.setEnvMap(textureCube);
        });
    },
    // eslint-disable-next-line no-unused-vars
    render(h) {
        return null;
    },
    methods: {
        ...mapActions('spinner', ['setEnvMap'])
    }
};
</script>
